import React from "react";

const TREND = {
    improving: { label: "Improving", color: "#4ade80", arrow: "↑" },
    worsening: { label: "Worsening", color: "#f87171", arrow: "↓" },
    stable:    { label: "Stable",    color: "#9feae8", arrow: "→" },
};

export default function TrendIndicator({ direction, showLabel = false }) {
    const cfg = TREND[direction] || TREND.stable;
    return (
        <span className="rd-trend-indicator" style={{ "--rd-trend-color": cfg.color }}>
            {cfg.arrow}
            {showLabel ? <span className="rd-trend-indicator-label">{cfg.label}</span> : null}
        </span>
    );
}
